import { QueryClient } from '@tanstack/react-query';

const isUnauthorized = (error: unknown): boolean => {
  if (error == null || typeof error !== 'object') return false;
  const err = error as {
    data?: { code?: string; httpStatus?: number };
    shape?: { data?: { code?: string } };
  };
  return (
    err.data?.code === 'UNAUTHORIZED' ||
    err.data?.httpStatus === 401 ||
    err.shape?.data?.code === 'UNAUTHORIZED'
  );
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 10, // 10 minutes (formerly cacheTime)
      retry: (failureCount, error) => {
        if (isUnauthorized(error)) return false;
        return failureCount < 1;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 1,
    },
  },
});
